var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3652 8.49234C22.1472 8.49259 22.5743 9.3954 22.081 10.0031L12.5312 21.7609C11.5624 22.9523 9.66646 21.9292 10.1298 20.467L10.1239 20.4611L13.7226 9.1359C13.843 8.75098 14.2043 8.49234 14.6073 8.49234H21.3652ZM11.4638 2.24039C12.4326 1.04901 14.3275 2.07211 13.8642 3.53433L13.871 3.54019L10.2724 14.8654C10.1519 15.2503 9.79064 15.5089 9.38762 15.5089H2.62981C1.84765 15.5088 1.42059 14.6059 1.91399 13.9982L11.4638 2.24039Z",
    fill: "url(#paint0_radial_6665_6479)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6665_6479",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9975 26.4278) rotate(-90) scale(37.9291 37.9718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1339D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711538,
    stopColor: "#1E278B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000E47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSign);
export default __webpack_public_path__ + "static/media/small-sign.8d5f2d51d42818e7041c0dd52d61b570.svg";
export { ForwardRef as ReactComponent };